import {
  TEMPLATE_DOCUMENTOS_LISTAR,
  TEMPLATE_DOCUMENTOS_OBTER,
  TEMPLATE_DOCUMENTOS_SALVAR,
  TEMPLATE_DOCUMENTOS_RESTAURAR,
  TEMPLATE_DOCUMENTOS_PREVIEW_PDF
} from "../actions/templateDocumentos";
import { ERRORS_SHOW } from "../actions/errors";
import Api from "../../service/api-web";

const actions = {
  [TEMPLATE_DOCUMENTOS_LISTAR]: ({ dispatch, getters }) => {
    return new Promise((resolve, reject) => {
      Api.v4.documentoLayout
        .listar(getters.getFornecedorId)
        .then(resp => {
          resolve(resp.data || []);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },

  [TEMPLATE_DOCUMENTOS_OBTER]: ({ dispatch, getters }, aliasDocumento) => {
    return new Promise((resolve, reject) => {
      Api.v4.documentoLayout
        .obter(getters.getFornecedorId, aliasDocumento)
        .then(resp => {
          resolve(resp.data || null);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },

  [TEMPLATE_DOCUMENTOS_SALVAR]: (
    { dispatch, getters },
    { aliasDocumento, html, ativo = true, metadados = {} }
  ) => {
    return new Promise((resolve, reject) => {
      Api.v4.documentoLayout
        .salvar(getters.getFornecedorId, aliasDocumento, {
          html,
          ativo,
          metadados
        })
        .then(resp => {
          resolve(resp.data || null);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },

  [TEMPLATE_DOCUMENTOS_RESTAURAR]: ({ dispatch, getters }, aliasDocumento) => {
    return new Promise((resolve, reject) => {
      Api.v4.documentoLayout
        .restaurar(getters.getFornecedorId, aliasDocumento)
        .then(resp => {
          resolve(resp.data || null);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },

  [TEMPLATE_DOCUMENTOS_PREVIEW_PDF]: (
    { dispatch, getters },
    { aliasDocumento, html }
  ) => {
    return new Promise((resolve, reject) => {
      const body =
        typeof html === "string" && html.trim().length > 0 ? { html } : {};
      Api.v4.documentoLayout
        .previewPdf(getters.getFornecedorId, aliasDocumento, body)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  }
};

export default {
  actions
};
